import api from './api';

const kadryService = {
  // Pobierz wszystkich pracowników
  getPracownicy: async () => {
    try {
      const response = await api.get('/kadry/pracownicy');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania pracowników:', error);
      throw error;
    }
  },

  // Aktualizuj dni urlopu pracownika (wymiar, przeniesione, bilans wejściowy, korekta)
  updatePracownikUrlop: async (userId, payload) => {
    try {
      // Wsparcie wstecznej kompatybilności: jeśli przekazano sam number,
      // traktuj go jak dniUrlopuRocznie.
      const body = (typeof payload === 'number' || typeof payload === 'string')
        ? { dniUrlopuRocznie: payload }
        : (payload || {});
      const response = await api.put(`/kadry/pracownicy/${userId}`, body);
      return response.data;
    } catch (error) {
      console.error('Błąd aktualizacji dni urlopu:', error);
      throw error;
    }
  },

  // Pobierz listę użytkowników do wyboru przełożonego
  getUsers: async () => {
    try {
      const response = await api.get('/kadry/users');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania użytkowników:', error);
      throw error;
    }
  },

  // ==================== WNIOSKI URLOPOWE ====================

  // Pobierz wszystkie wnioski urlopowe
  getWnioskiUrlopowe: async () => {
    try {
      const response = await api.get('/kadry/wnioski-urlopowe');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania wniosków urlopowych:', error);
      throw error;
    }
  },

  // Pobierz wnioski do podpisania (dla przełożonych)
  getWnioskiDoPodpisania: async () => {
    try {
      const response = await api.get('/kadry/wnioski-do-podpisania');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania wniosków do podpisania:', error);
      throw error;
    }
  },

  // Pobierz wnioski już podpisane przez przełożonego
  getWnioskiPodpisane: async () => {
    try {
      const response = await api.get('/kadry/wnioski-podpisane');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania podpisanych wniosków:', error);
      throw error;
    }
  },

  // Podpisz wniosek urlopowy jako przełożony
  podpiszWniosekUrlopowy: async (wniosekId, podpisData) => {
    try {
      const response = await api.put(`/kadry/wnioski-urlopowe/${wniosekId}/podpisz`, podpisData);
      return response.data;
    } catch (error) {
      console.error('Błąd podpisywania wniosku urlopowego:', error);
      throw error;
    }
  },

  // Zwróć wniosek urlopowy do pracownika do poprawy
  zwrocUrlopDoPracownika: async (id, komentarz) => {
    const response = await api.put(`/kadry/wnioski-urlopowe/${id}/zwroc-do-pracownika`, { komentarz });
    return response.data;
  },

  // Pobierz pojedynczy wniosek urlopowy
  getWniosekUrlopowy: async (id) => {
    const response = await api.get(`/kadry/wnioski-urlopowe/${id}`);
    return response.data;
  },

  // Popraw wniosek urlopowy po zwrocie
  updateWniosekUrlopowy: async (id, wniosekData) => {
    const response = await api.put(`/kadry/wnioski-urlopowe/${id}`, wniosekData);
    return response.data;
  },

  // Upload załącznika do wniosku (osobny request)
  uploadZalacznikWniosek: async (file) => {
    const fd = new FormData();
    fd.append('zalacznik', file);
    const response = await api.post('/kadry/wnioski-urlopowe/upload-zalacznik', fd);
    return response.data;
  },

  // Utwórz nowy wniosek urlopowy (wniosekData – obiekt JSON)
  createWniosekUrlopowy: async (wniosekData) => {
    try {
      const response = await api.post('/kadry/wnioski-urlopowe', wniosekData);
      return response.data;
    } catch (error) {
      console.error('Błąd tworzenia wniosku urlopowego:', error);
      throw error;
    }
  },

  getKontekstZlozeniaWnioskuUrlopowego: async () => {
    const response = await api.get('/kadry/wnioski-urlopowe/kontekst-zlozenia');
    return response.data;
  },

  // Pobierz załącznik jako blob (do wyświetlenia w nowej karcie / pobrania)
  fetchZalacznik: async (wniosekId) => {
    const response = await api.get(`/kadry/wnioski-urlopowe/${wniosekId}/zalacznik`, { responseType: 'blob' });
    return response.data;
  },

  // Cofnij wniosek urlopowy (tylko jeśli nie został jeszcze podpisany)
  cofnijWniosekUrlopowy: async (wniosekId) => {
    try {
      const response = await api.put(`/kadry/wnioski-urlopowe/${wniosekId}/cofnij`);
      return response.data;
    } catch (error) {
      console.error('Błąd cofania wniosku urlopowego:', error);
      throw error;
    }
  },

  // Usuń podpisany wniosek urlopowy (tylko super admin) — wymaga powodu
  usunWniosekUrlopowy: async (wniosekId, powod) => {
    const response = await api.delete(`/kadry/wnioski-urlopowe/${wniosekId}`, {
      data: { powod }
    });
    return response.data;
  },

  // ==================== WNIOSKI DELEGACYJNE ====================

  // Pobierz wszystkie wnioski delegacyjne
  getWnioskiDelegacyjne: async () => {
    try {
      const response = await api.get('/kadry/wnioski-delegacyjne');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania wniosków delegacyjnych:', error);
      throw error;
    }
  },

  // Pobierz pojedynczy wniosek delegacyjny
  getWniosekDelegacyjny: async (id) => {
    try {
      const response = await api.get(`/kadry/wnioski-delegacyjne/${id}`);
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania wniosku delegacyjnego:', error);
      throw error;
    }
  },

  // Utwórz nowy wniosek delegacyjny
  createWniosekDelegacyjny: async (wniosekData) => {
    try {
      const response = await api.post('/kadry/wnioski-delegacyjne', wniosekData);
      return response.data;
    } catch (error) {
      console.error('Błąd tworzenia wniosku delegacyjnego:', error);
      throw error;
    }
  },

  // Aktualizuj wniosek delegacyjny
  updateWniosekDelegacyjny: async (id, wniosekData) => {
    try {
      const response = await api.put(`/kadry/wnioski-delegacyjne/${id}`, wniosekData);
      return response.data;
    } catch (error) {
      console.error('Błąd aktualizacji wniosku delegacyjnego:', error);
      throw error;
    }
  },

  // Podpisz polecenie wyjazdu jako przełożony
  podpiszWniosekDelegacyjny: async (id, podpisData) => {
    try {
      const response = await api.put(`/kadry/wnioski-delegacyjne/${id}/podpisz`, podpisData);
      return response.data;
    } catch (error) {
      console.error('Błąd podpisywania wniosku delegacyjnego:', error);
      throw error;
    }
  },

  // Potwierdź uzupełnienie rachunku kosztów (autor)
  potwierdzRachunekKosztowDelegacji: async (id) => {
    try {
      const response = await api.put(`/kadry/wnioski-delegacyjne/${id}/rachunek-potwierdz`);
      return response.data;
    } catch (error) {
      console.error('Błąd potwierdzania rachunku delegacji:', error);
      throw error;
    }
  },

  zwrocDelegacjeDoPracownika: async (id, komentarz) => {
    try {
      const response = await api.put(`/kadry/wnioski-delegacyjne/${id}/zwroc-do-pracownika`, { komentarz });
      return response.data;
    } catch (error) {
      console.error('Błąd zwrotu delegacji do pracownika:', error);
      throw error;
    }
  },

  zwrocPolecenieDelegacjiDoPracownika: async (id, komentarz) => {
    const response = await api.put(`/kadry/wnioski-delegacyjne/${id}/zwroc-polecenie-do-pracownika`, { komentarz });
    return response.data;
  },

  usunDelegacje: async (id) => {
    const response = await api.delete(`/kadry/wnioski-delegacyjne/${id}`);
    return response.data;
  }
};

export default kadryService;

